export enum Dimension {
  //#region High Level
  /**ADMIN ONLY */
  ORGANIZATION_NAME = 'organization_name',
  CLIENT_NAME = 'client_name',
  CLIENT_EXTERNAL_ID = 'client_external_id',
  ADVERTISER_NAME = 'advertiser_name',
  CAMPAIGN_NAME = 'campaign_name',
  LINE_ITEM_NAME = 'line_item_name',
  /**LOCALITY ONLY */
  LINE_ITEM_ALT_ID = 'line_item_name_alternative_id',
  CAMPAIGN_START_DATE = 'campaign_start_date',
  CAMPAIGN_END_DATE = 'campaign_end_date',
  LINE_ITEM_START_DATE = 'line_item_start_date',
  LINE_ITEM_END_DATE = 'line_item_end_date',
  //#endregion
  //#region Booked Totals
  CAMPAIGN_BOOKED_IMPRESSIONS = 'campaign_booked_impressions',
  LINE_ITEM_BOOKED_IMPRESSIONS = 'line_item_booked_impressions',
  //#endregion
  //#region Creative
  CREATIVE_NAME = 'creative_name_mapped',
  CREATIVE_ID = 'creative_id_mapped',
  CREATIVE_DURATION = 'creative_duration',
  CREATIVE_FORMAT = 'creative_format',
  //#endregion
  //#region Inventory
  DIGITAL_CHANNEL = 'digital_channel',
  PUBLISHER_NAME = 'publisher_name_mapped',
  CONTENT_NETWORK = 'content_network',
  CONTENT_CHANNEL = 'content_channel',
  DEVICE_TYPE = 'device_type',
  CONTENT_GENRE = 'genre',
  CONTENT_TITLE = 'program',
  //#endregion
  //#region Geography
  STATE = 'state',
  DMA = 'dma',
  CITY = 'city',
  ZIP = 'zip',
  //#endregion
  //#region Daypart
  DAYPART = 'daypart',
  DAY_OF_WEEK = 'day_of_week',
  HOUR_OF_DAY = 'hour_of_day',
  //#endregion
  //#region CPM
  RATE_CARD = 'rate_card',
  SOLD_CPM = 'sold_cpm',
  //#endregion
  //#region Audience
  // AUDIENCE = 'audience', // left out for now
  //#endregion
  //#region Conversions
  EVENT_ID = 'ip_conversion_event_id',
  EVENT_NAME = 'event_name',
  //#endregion
}

export default Dimension;
